import { Box } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

export const ReadingProgressBar = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight > 0) {
        setProgress(Math.min(100, (scrollTop / docHeight) * 100));
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      h="3px"
      bg="purple.400"
      zIndex="banner"
      transition="width 100ms linear"
      w={`${progress}%`}
      css={{ '@media (prefers-reduced-motion: reduce)': { transition: 'none' } }}
    />
  );
};
